const TECH_EDITOR_REDIRECT_PATHS = new Set([
  'tech-editor',
  '/tech-editor',
  'tech-editor-v2',
  '/tech-editor-v2',
]);

export function buildAuthAsRedirectUrl(
  redirectTo: string,
  selectedItem?: string
): string {
  const destination = redirectTo || '/buyer-home';
  if (!selectedItem) return destination;

  const fragmentIndex = destination.indexOf('#');
  const fragment = fragmentIndex >= 0 ? destination.slice(fragmentIndex) : '';
  const urlWithoutFragment = fragmentIndex >= 0
    ? destination.slice(0, fragmentIndex)
    : destination;
  const queryIndex = urlWithoutFragment.indexOf('?');
  const path = queryIndex >= 0
    ? urlWithoutFragment.slice(0, queryIndex)
    : urlWithoutFragment;
  const query = queryIndex >= 0 ? urlWithoutFragment.slice(queryIndex) : '';
  const normalizedPath = path.replace(/\/+$/, '');
  const encodedItem = encodeURIComponent(selectedItem);

  if (TECH_EDITOR_REDIRECT_PATHS.has(normalizedPath)) {
    return `${path};stack=${encodedItem}${query}${fragment}`;
  }

  const separator = query ? '&' : '?';
  return `${urlWithoutFragment}${separator}selectedItem=${encodedItem}${fragment}`;
}
